import React from "react";
import "./SellRegisterToday.css";
import { formattedText } from "@/components/sell/utils/TextFormatter";

const SellRegisterToday = ({ cmsData = [] }) => {
  // Safely access the data with fallbacks
  const hubzuCmsData = cmsData?.[0]?.register || {};

  const handleNavigate = () => {
    window.location.href = cmsData[0]?.externalAppUrl || "";
  };

  return (
    <div className="sell-register-section text-center">
      <h2>{hubzuCmsData?.title}</h2>
      <div className="sell-register-para">
        <p>{hubzuCmsData?.description}</p>
        <div className="sellParaBold">
          <p>{formattedText(hubzuCmsData?.contact)}</p>
        </div>
      </div>
      {hubzuCmsData?.title && (
        <button
          className="btn btn-thm btn-lg sell-register-today-button"
          onClick={handleNavigate}
        >
          <span className="ctus-fnt-new">Register Today</span>
        </button>
      )}
    </div>
  );
};

export default SellRegisterToday;
